import { useSelector } from 'react-redux';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { useMembershipApi } from './apiHooks';
import { CENTURION } from '../constants/commonConstants';
import { MembershipResponse } from '../types/data.types';

export const useTopCard = () => {
  const { data: membershipData } = useMembershipApi();
  return membershipData?.data?.membership?.find(
    (account: MembershipResponse) => account.demographics.isTopCard
  );
};

export const useIsCenturion = () => {
  const topCard = useTopCard();
  return !topCard ? false : topCard?.demographics.product.productFamily === CENTURION;
};

export const useGetMRPointsBalance = () => {
  const topCard = useTopCard();
  const activeLocale: string = useSelector(getActiveLocaleSelector);
  return !topCard ? '' : topCard?.loyalty?.pointsBalance.toLocaleString(activeLocale);
};

export const useGetTopCardDescription = () => {
  const topCard = useTopCard();
  const topCardProduct = topCard?.demographics?.product;
  return topCardProduct ? topCardProduct.description ?? topCardProduct.productFamily : '';
};
